import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { LoadUserAction, LogInAction, LogOutAction, SyncStart, SyncStop } from './user-actions';
import { User } from '../models/user.model';

export interface UserStateModel {
  user: User|null;
}

@State<UserStateModel>({
  name: 'user',
  defaults: {
    user: null
  }
})
@Injectable()
export class UserState {
  @Action(LoadUserAction)
  loadUser(ctx: StateContext<UserStateModel>, action: LoadUserAction) {
      const usr = JSON.parse(localStorage.getItem('user'));
      ctx.setState(
        {user: usr}
      );
  }

  @Action(LogInAction)
  setUser(ctx: StateContext<UserStateModel>, action: LogInAction) {
    ctx.setState({
      user: action.user
    });
    localStorage.setItem('user', JSON.stringify(action.user));
  }

  @Action(LogOutAction)
  deletItem(ctx: StateContext<UserStateModel>, action: LogOutAction) {
    const state = ctx.getState();
    //const newTodoItems = state.items.filter((item) =>  {return item.id!== action.id });
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    ctx.setState({ user: null });
  }

  @Action(SyncStart)
  syncStart(ctx: StateContext<UserStateModel>, action: SyncStart) {
    const usr: any = {};
    Object.assign(usr, ctx.getState().user);
    usr.session = true;
    ctx.setState({
      user: usr
    });
    localStorage.setItem('user', JSON.stringify(usr));
  }

  @Action(SyncStop)
  syncStop(ctx: StateContext<UserStateModel>, action: SyncStop) {
    const usr: any = {};
    Object.assign(usr, ctx.getState().user);
    usr.session = false;
    ctx.setState({
      user: usr
    });
    localStorage.setItem('user', JSON.stringify(usr));
  }

}
